import { registerComponent } from '@gig/magic-common';
import MenuItemComponent from './menu-item.vue.js';

var MenuItem = registerComponent(MenuItemComponent);

export { MenuItem };
